import classes from "./Checkbox.module.css";

/*
 *
 * Created on Thu 12 May 2023
 *
 * Copyright (c) 2023 One97 communications
 * @author poonam.chandra
 * @modified By :
 *
 */

const CheckBox = ({
  id,
  label,
  name,
  checked,
  onChange,
  errormsg,
  errorStyle = {},
  labelStyle = {},
}) => {
  return (
    <div style={{ textAlign: "left" }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <input
          name={name}
          onChange={onChange}
          checked={checked}
          type="checkbox"
          id={id}
          role="switch"
          className={classes.checkInput}
        />
        <label
          htmlFor={id}
          className={classes.label}
          style={{ ...labelStyle }}
        >{label}</label>
      </div>
      {errormsg && (
        <label className={classes.error} style={{ ...errorStyle }}>
          {errormsg}
        </label>
      )}
    </div>
  );
};

export default CheckBox;
